import * as yup from 'yup';
import dayjs from './dayjs';

yup.addMethod(yup.string, 'beforeDate', function (ref, message) {
  return this.test('before-date', message, function (value) {
    const { path, createError } = this;
    const endDate = this.resolve(ref);

    if (!value || !endDate) return true;

    return (
      dayjs.utc(value).isSameOrBefore(dayjs.utc(endDate)) ||
      createError({ path, message })
    );
  });
});

yup.addMethod(yup.string, 'afterDate', function (ref, message) {
  return this.test('after-date', message, function (value) {
    const { path, createError } = this;
    const startDate = this.resolve(ref);

    if (!value || !startDate) return true;

    return (
      dayjs.utc(value).isSameOrAfter(dayjs.utc(startDate)) ||
      createError({ path, message })
    );
  });
});

yup.addMethod(yup.string, 'betweenDates', function (ref1, ref2, message) {
  return this.test('between-dates', message, function (value, ctx) {
    const { path, createError } = this;
    const startDate = ref1(ctx);
    const endDate = ref2(ctx);

    if (!value || !startDate || !endDate) return true;

    return (
      (dayjs.utc(value).isSameOrAfter(dayjs.utc(startDate)) &&
        dayjs.utc(value).isSameOrBefore(dayjs.utc(endDate))) ||
      createError({ path, message })
    );
  });
});

export default yup;
